/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@eureca/candidate-api-sdk/client';
import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';
import type {
  GetMyIdentityConfirmationQueryResponse,
  GetMyIdentityConfirmation401,
  GetMyIdentityConfirmation502,
  GetMyIdentityConfirmation503,
} from '../types/GetMyIdentityConfirmation.ts';

function getGetMyIdentityConfirmationUrl() {
  const res = { method: 'GET', url: `/me/identity-confirmation` as const };
  return res;
}

/**
 * {@link /me/identity-confirmation}
 */
export async function getMyIdentityConfirmation(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetMyIdentityConfirmationQueryResponse,
    ResponseErrorConfig<
      GetMyIdentityConfirmation401 | GetMyIdentityConfirmation502 | GetMyIdentityConfirmation503
    >,
    unknown
  >({ method: 'GET', url: getGetMyIdentityConfirmationUrl().url.toString(), ...requestConfig });
  return res.data;
}
